// extracted by mini-css-extract-plugin
module.exports = {"Button":"_3bi60-3WEz-JGyftVhz_Ki","Success":"_3LPfrmP3A3YnLb8Qb2y4Xt","Danger":"_3Zyj7CNiZ7EvdlS--6hAwq"};